import { FormattedMessage } from "react-intl";
import CardInfo from "../CardInfo";
import Container from "./Container";
import { Col, Divider, Row } from "antd";
import ChartsComponent from "../Charts";
import CardTotalPerYear from "../CardTotalPerYear";

const FourthBlock = ({ potentialImpact }) => {
  const children = (
    <Row align={"stretch"} gutter={[16, 16]}>
      <Col span={7}>
        <ChartsComponent
          label={<FormattedMessage id="bracestreatmentSaved" />}
          value1={Math.round(potentialImpact?.braces?.low)}
          value2={Math.round(potentialImpact?.braces?.high)}
          unit={false}
        />
      </Col>
      <Col span={1}>
        <Divider type="vertical" className="roi--divider-vertical" />
      </Col>
      <Col span={7}>
        <ChartsComponent
          label={<FormattedMessage id="alignertreatmentSaved" />}
          value1={Math.round(potentialImpact?.aligners?.low)}
          value2={Math.round(potentialImpact?.aligners?.high)}
          unit={false}
        />
      </Col>
      <Col span={9}>
        <CardTotalPerYear
          title={<FormattedMessage id="totalPerYear" />}
          value1={Math.round(potentialImpact?.totalPerYear?.total)}
          value2={Math.round(potentialImpact?.totalPerYear?.braces)}
          value3={Math.round(potentialImpact?.totalPerYear?.aligners)}
        />
      </Col>
    </Row>
  );
  return (
    <Container
      blockTitle={"potentialImpactSaved"}
      title={"why"}
      content={"impactPatientInfo"}
      children={children}
    />
  );
};

export default FourthBlock;
